import PageWrapper from '@app/components/layout/PageWrapper';
import FullLoader from '@app/components/ui/FullLoader';
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

const EditVisitPage = lazy(() => import('@pages/visits/EditVisitPage'));
const VisitsPage = lazy(() => import('@pages/visits/VisitsListPage'));
const VisitSummariesPage = lazy(() => import('@pages/visits/VisitSummariesListPage'));
const ForcedAssignmentsPage = lazy(() => import('@pages/visits/ForcedAssignmentsListPage'));

// Route Components
const VisitTablePage = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('visits-page-title')}>
        <VisitsPage />
      </PageWrapper>
    </Suspense>
  );
};

const VisitEditPage = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('visits-edit-page-title')}>
        <div className="h-full overflow-y-auto">
          <EditVisitPage />
        </div>
      </PageWrapper>
    </Suspense>
  );
};

const VisitSummariesTablePage = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('visit-summaries-page-title')}>
        <VisitSummariesPage />
      </PageWrapper>
    </Suspense>
  );
};

const ForcedAssignmentsTablePage = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('forced-assignments-page-title')}>
        <ForcedAssignmentsPage />
      </PageWrapper>
    </Suspense>
  );
};

// Export Lazy-Loaded Route
export default {
  VisitTablePage,
  VisitEditPage,
  VisitSummariesTablePage,
  ForcedAssignmentsTablePage,
};
